import { io, Socket } from 'socket.io-client';
import type { EngagementSnapshot } from '@/types/emotion';

type ServerToClientEvents = {
  'engagement:update': (payload: { snapshots: EngagementSnapshot[]; sessionId: string }) => void;
  'session_ended': (payload: { averageEngagement: number }) => void;
};

type ClientToServerEvents = {
  'engagement:publish': (payload: EngagementSnapshot) => void;
  'session:join': (payload: { sessionId: string; role: 'student' | 'instructor' }) => void;
};


let socket: Socket;

export const getSocket = () => {
  if (!socket) {
    socket = io(import.meta.env.VITE_BACKEND_SOCKET_URL ?? import.meta.env.VITE_BACKEND_URL ?? 'http://localhost:4000', {
      // 1. FORCE WebSocket only (removes polling to fix "closed before established" errors)
      transports: ['websocket'], 
      
      // 2. Add Credentials (helps pass strict CORS checks on custom domains)
      withCredentials: true,
      
      autoConnect: false
    });
  }
  return socket;
};

